import { useEffect, useState } from 'react';

export default function useDebounce(callback: any, delay: number) {
  const [debounceValue, setDebounceValue] = useState(callback);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(callback);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
  return debounceValue;
}
